import { Alert, Box, Button, IconButton, Snackbar } from '@mui/material';
import React, { useEffect, useState } from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DeleteIcon from '@mui/icons-material/Delete';
import IosShareIcon from '@mui/icons-material/IosShare';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import Setting from '../assets/icons/stetting.svg';
import video from '../assets/icons/video.svg';
import esercizi from '../assets/icons/esercizi.svg';
import manina from '../assets/icons/manina.svg';
import spot from '../assets/icons/spot.svg';
import EsercizioDetails from '../components/EsercizioDetails';
import VideoTrack from '../components/VideoTrack';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Esercizio, esercizioVuoto } from '../interfaces/Esercizio';
import JsonUpload from '../components/JsonUpload';
import { MODALTYPE, ModalData, modalDataClean, ModalAlert } from '../components/ModalAlert';
import AutoTrattamentoDetails from '../components/AutoTrattamentoDetails';
import SportEducativoDetails from '../components/SportEducativoDetails';
import SpinnerODM from '../components/spinnerODM';
import { useEsercizioStore } from '../utils/store';
import Video3DTrack from '../components/Video3DTrack';
import { isValidEsercizio } from '../interfaces/isValidFromPubished';
import MasterHeader from '../components/MasterHeder';


//interface EsercizioPageProps {
//  token: string;
//}

const EsercizioPage: React.FC = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const { id } = useParams<{ id: string }>();
  const [loading, setLoading] = useState<boolean>(false);

  const initialEsercizio = useEsercizioStore(state => state.esercizio) // (location.state && (location.state as any).esercizio) || esercizioVuoto;
  const [esercizio, setEsercizio] = useState<Esercizio>(initialEsercizio);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  //const esercizio = useEsercizioStore(state => state.esercizio);

  const [dirty, setDirty] = useState<boolean>(false);

  const [modalData, setModalData] = useState<ModalData>(modalDataClean);
  const [activeTab, setActiveTab] = useState<number>(1);
  const navigate = useNavigate();
  const esercizioFromStore = useEsercizioStore(state => state.esercizio)

  useEffect(() => {
    if (!id || location.state) {
      return;
    }

    if (esercizioFromStore && esercizioFromStore.id != Number(id)) {
      setLoading(true);
      const headers = new Headers();
      headers.set('Accept', 'application/json');
      const requestInit: RequestInit = {
        method: 'GET',
        headers: headers,
        credentials: 'include',
      };

      fetch(`/api/v0/activity/${id}`, requestInit)
        .then(response => response.json())
        .then(data => {
          setEsercizio(data);
        })
        .catch(error => console.error("Errore nel recupero dell'esercizio:", error))
        .finally(() => setLoading(false));
    }
  }, [id, location.state]);

  const handleChange = <K extends keyof Esercizio>(key: K, value: Esercizio[K]) => {
    setEsercizio(prev => ({ ...prev, [key]: value }));
    setDirty(true);
  };


  const salvaEsercizio = async (dati: Esercizio) => {
    setLoading(true)
    try {
      const url = id ? `/api/v0/activity/${id}/partial-update` : '/api/v0/activity/new';
      const method = id ? 'PUT' : 'POST';

      let formData = new FormData()
      const dati_partial: Partial<Esercizio> = dati;
      if (dati_partial.preview_image) {
        if (typeof dati_partial.preview_image === "string") {
          delete dati_partial.preview_image
        }
        if (dati_partial.preview_image instanceof File) {
          formData.append('preview_image', dati_partial.preview_image!)
        }
      }
      if (dati_partial.video) {
        if (typeof dati_partial.video === "string") {
          delete dati_partial.video
        }
        if (dati_partial.video instanceof File) {
          formData.append('video', dati_partial.video!)
        }
      }
      if (dati_partial.animation) {
        if (typeof dati_partial.animation === "string") {
          delete dati_partial.animation
        }
        if (dati_partial.animation instanceof File) {
          formData.append('animation', dati_partial.animation!)
        }
      }
      if (dati_partial.body_tracking) {
        if (dati_partial.body_tracking!='body_tracking_uploaded'){
          formData.append('body_tracking', dati_partial.body_tracking!);
        } else {
          delete dati_partial.body_tracking
        }
      }
      formData.append('fields', JSON.stringify(dati_partial))

      const headers = new Headers();
      //if (token) {
      //  headers.set('Authorization', `Token ${token}`);
      //}
      // headers.set('Content-Type', 'multipart/form-data');
      const requestInit: RequestInit = {
        method,
        headers: headers,
        body: formData,
        credentials: 'include',
      }
      const response = await fetch(url, requestInit);

      if (!response.ok) {
        const errorData = await response.json();
        const messages = Object.entries(errorData)
          .map(([field, errors]) => `${field}: ${Array.isArray(errors) ? errors.join(', ') : errors}`)
          .join('\n');
        throw new Error(messages);
      }

      const data = await response.json();
      setEsercizio(data);
      console.log("Esercizio aggiornato:", data);
      navigateToParent()
    } catch (error: any) {
      console.error("Errore durante la chiamata API:", error);
      setModalData({
        show: true,
        title: "",
        message: error.message || "Errore durante il salvataggio dell'esercizio",
        type: MODALTYPE.OK,
      })
    }
    setLoading(false)
  };

  const eliminaEsercizio = async () => {
    setLoading(true);
    if (!id) return;
    try {
      const headers = new Headers();
      const response = await fetch(`/api/v0/activity/${id}`, {
        method: "DELETE",
        headers: headers,
        credentials: 'include',
      });

      if (!response.ok) {
        throw new Error("Errore durante l'eliminazione dell'esercizio");
      }

      setSnackbarOpen(true);
      setTimeout(() => {
        navigateToParent();
      }, 1000);
    } catch (error: any) {
      console.error("Errore durante la chiamata DELETE:", error);
      setModalData({
        show: true,
        title: "",
        message: error.message || "Si è verificato un errore durante l'eliminazione dell'esercizio",
        type: MODALTYPE.OK,
      });
      setLoading(false);
    }
  };


  const salva = async () => {
    await salvaEsercizio(esercizio);
    setDirty(false)
  };

  const tornaInditro = () => {
    if (dirty) {
      setModalData({
        show: true,
        title: "Tornare indietro?",
        message: "Se torni indietro senza salvare perderai tutte le informazioni aggiunte. Vuoi procedere?",
        type: MODALTYPE.CONFIRM,
        action: () => navigate('/esercizi'),
      });
    } else {
      navigate('/esercizi');
    }
  };

  const elimina = () => {
    const deleteExercice = async () => {
      await eliminaEsercizio();
    }
    setModalData({
      show: true,
      title: "Elimina elemento",
      message: esercizio.status === "Published" ?
        "Se decidi di procedere, questo elemento verrà eliminato definitivamente dall'app in tutte le sessioni in cui è presente dal backoffice." :
        "Se decidi di procedere, questo elemento verrà eliminato definitivamente dal backoffice.",
      type: MODALTYPE.DELETE,
      action: deleteExercice
    })
  };


  const aggiornaPubblicazione = async () => {
    setLoading(true)
    const nuovoStatus = esercizio.status === "Published" ? "Publishable" : "Published";
    const esercizioAggiornato = { ...esercizio, status: nuovoStatus };
    await salvaEsercizio(esercizioAggiornato);
  };

  const statoBadge = esercizio.status === "Published"
    ? <span className="badge text-bg-success">Pubblicato</span>
    : <span className="badge text-bg-danger">Non pubblicato</span>;

  const closeModal = () => setModalData(prev => ({ ...prev, show: false }));


  const navigateToParent = () => {
    navigate(-1);
  };

  useEffect(() => {

    switch (esercizio.type) {
      case "Exercise":
        setActiveTab(1);
        break;
      case "SelfTreatment":
        setActiveTab(2);
        break;
      case "EducationalSpot":
        setActiveTab(3);
        break;
      default:
        setActiveTab(1);
    }

  }, [id, esercizio.type]);

  if (loading) {
    return (<>
      <SpinnerODM />
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={() => setSnackbarOpen(false)} severity="success" sx={{ width: '100%' }}>
          Esercizio eliminato con successo.
        </Alert>
      </Snackbar>
    </>
    )
  }

  return (
    <Box sx={{ display: "flex", height: "100%", width: "100%" }}>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          height: "100%",
          width: "100%",
          overflow: "hidden",
        }}
      >
        <MasterHeader
          tipo={"esercizio"}
          statoBadge={statoBadge}
          elimina={elimina}
          nomeElemento={id == null ? "Nuovo Elemento" : esercizio.full_name}
          salvaModifica={salva}
          aggiornaPubblicazione={aggiornaPubblicazione}
          status={esercizio.status}
          stateSave={false}
          statePublished={esercizio.status !== "Published" && !isValidEsercizio(esercizio)}
          deleteDisabled={esercizio.id==null}
        />

        <Box
          component="main"
          sx={{
            height: "100%",
            width: "100%",
            overflow: "hidden",
            paddingBottom: 17
          }}
        >
          <div className="backgroundPage row row-cols-1 row-cols-lg-2 p-3" style={{ height: "100%" }}>
            <div className="col" style={{ height: "90%" }}>
              <div className='d-flex'>
                <img src={Setting} alt="icon" width={30} />
                <h3 className='ms-3'>Parametri</h3>
              </div>

              <div className="white-panel p-3" style={{ height: "100%", overflowY: "auto" }}>
                {(activeTab === 1 || esercizio.type === "Exercise") && (
                  <EsercizioDetails esercizio={esercizio} handleChange={handleChange} />
                )}
                {(activeTab === 2 || esercizio.type === "SelfTreatment") && (
                  <AutoTrattamentoDetails esercizio={esercizio} handleChange={handleChange} />
                )}
                {(activeTab === 3 || esercizio.type === "EducationalSpot") && (
                  <SportEducativoDetails esercizio={esercizio} handleChange={handleChange} />
                )}
              </div>

            </div >
            <div className="col" style={{ height: "90%" }}>
              <div className='d-flex'>
                <img src={video} alt="icon" width={30} />
                <h3 className='ms-3'>Video</h3>
              </div>
              <div style={{ height: "100%", overflowY: "auto" }}>
                {activeTab == 1 && (<>
                  <div className="white-panel p-3 mb-3" style={{ maxHeight: "50vh" }}>
                    <VideoTrack
                      title="Video originale"
                      description="Carica il contenuto originale se vuoi tenere traccia del video dal quale haiestratto il file di Body tracking (.json)"
                      acceptedFileType="video/mp4"
                      file={esercizio.video}
                      field="video"
                      handleChange={handleChange}
                    />
                  </div>
                  <div className="white-panel p-3 mb-3" style={{ maxHeight: "50vh" }}>
                    <Video3DTrack
                      title="Animazione 3D*"
                      description="Assicurati che l'animazione(.usdz) riproduca una singola ripetizione dell'esercizio in quanto questa verrà ripetuta in loop sull'app."
                      acceptedFileType="usdz"
                      file={esercizio.animation}
                      field="animation"
                      handleChange={handleChange}
                      filename={esercizio.filename_animation}
                    />
                  </div>
                  <div className="white-panel p-3" style={{ maxHeight: "50vh" }}>
                    <JsonUpload
                      title="Body tracking* (.json)"
                      description="Assicurati che il video da cui ha origine il file .json riproduca una singola ripetizione dell'esercizio in quanto questa verrà usata come modell del movimento ottimale."
                      acceptedFileType=".json"
                      file={esercizio.body_tracking}
                      field="body_tracking"
                      handleChange={handleChange}
                      filename={esercizio.filename_json}
                    />
                  </div>
                </>
                )}
                {activeTab == 2 && (<>
                  <div className="white-panel p-3 mb-3" style={{ maxHeight: "50vh" }}>
                    <VideoTrack
                      title="Video originale"
                      description="Carica il contenuto originale se vuoi tenere traccia del video dal quale haiestratto il file di Body tracking (.json)"
                      acceptedFileType="video/mp4"
                      file={esercizio.video}
                      field="video"
                      handleChange={handleChange}
                    />
                  </div>
                </>
                )}
                {activeTab == 3 && (
                  <div className="white-panel p-3 mb-3" style={{ maxHeight: "50vh" }}>
                    <VideoTrack
                      title="Video originale"
                      description="Carica il contenuto originale se vuoi tenere traccia del video dal quale haiestratto il file di Body tracking (.json)"
                      acceptedFileType="video/mp4"
                      file={esercizio.video}
                      field="video"
                      handleChange={handleChange}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </Box >
        <ModalAlert
          modalData={modalData}
          onClose={closeModal} />
      </Box >
    </Box >

  );
};

export default EsercizioPage;